import {PATHS} from '@freckle/educator-entities/ts/common/helpers/paths'
import {Link} from '@freckle/educator-materials/ts/components/link'
import {H1} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'

export function NotFoundComponent() {
  const {t} = useSafeTranslation()

  return (
    <div className="row">
      <div className="col-12 text-center">
        <div className="row">
          <div className="col-12">
            <H1>{t('NOT_FOUND_COMPONENT_H1_TITLE')}</H1>
          </div>
        </div>

        <div className="row std-margin-top-xlg">
          <div className="col-12">
            <Link href={PATHS.schoolDashUrl} reactRouter>
              {t('NOT_FOUND_COMPONENT_LINK_HOME')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
